'use client';

import { X_SIGNUP_EVENT_ID } from '@/lib/analytics/x-ads';
import { reportConversionOnce } from '@/lib/analytics/conversion-once';

/** 注册完成到落地页之间的容忍窗口，超出则视为老用户回访 */
const SIGNUP_WINDOW_MS = 30 * 60 * 1000;

/**
 * 上报 X (Twitter) Ads Signup 转化。
 * 注册入口有多个（/sign-up 重定向、Studio 弹窗、Playground 弹窗），落地页也不统一，
 * 因此不绑定具体页面，改为按 Clerk 账号创建时间判定「刚注册」。
 */
export async function reportXSignupConversion(
  params: { userId: string; createdAtMs: number; email?: string | null },
  signal?: AbortSignal,
): Promise<void> {
  const { userId, createdAtMs } = params;
  if (!userId || !createdAtMs) return;

  const elapsed = Date.now() - createdAtMs;
  if (elapsed < 0 || elapsed > SIGNUP_WINDOW_MS) return;

  await reportConversionOnce({
    key: `x_signup_${userId}`,
    persist: 'local',
    isReady: () => typeof window.twq === 'function',
    signal,
    send: () => {
      window.twq?.('event', X_SIGNUP_EVENT_ID, {
        // 以 userId 去重，本地标记被清后 X 侧仍不会重复计数
        conversion_id: userId,
        // 明文邮箱由 uwt.js 自行哈希后上报，用于提升转化匹配率
        email_address: params.email || null,
      });
    },
  });
}
